<template>
    <!--header-->
    <div class="header">
        <div class="topbar" style="z-index: 1000">
            <div class="container">
                <div class="account-sign-status left">
                    欢迎来到有木头
                    <template v-if="username.length === 0">
                        <a href="/login">请登录</a><a href="/reg">免费注册</a>
                    </template>
                    <template v-else>
                        <a href="/member/info/">{{ username }}</a>
                    </template>
                </div>
                <div class="topnav right">
                    <a href="/member/info/">我的有木</a>
                    <a class="down">有木头公众号<img src="../assets/images/code1.jpg"></a>
                    <a class="down">有木头小程序<img src="../assets/logo/xiao_shop.jpg"></a>
                    <a href="/support/software">APP下载</a>
                </div>
            </div>
        </div>
        <div class="youmuhead">
            <ul class="container">
                <li class="left"><a href="/"><img src="../assets/images/logo1.png"></a></li>
                <li class="so right">
                    <input type="text" v-model="search" @keyup.enter="searchResult" placeholder="输入关键词/锯材树种"/>
                    <span @click="searchResult"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                username: '',
                search: ''
            }
        },

        mounted() {
            this.checkLogin();
            this.bus.$on('search', function (val) {
                this.search = val
            }.bind(this))
        },

        methods: {
            checkLogin() {
                let isLogin = Boolean(window.localStorage.getItem('userhashid'));
                if (isLogin) {
                    this.$http.get(this.ym_api + '/passport/get_username/').then((resp) => {
                        if (resp.data.status) {
                            this.username = resp.data.username;
                            this.isLogin = true;
                            this.bus.$emit('isLogin', true)
                        } else {
                            window.localStorage.removeItem('userhashid');
                            this.isLogin = false;
                            this.bus.$emit('isLogin', false)
                        }
                    }).catch((error) => {
                        console.log(error)
                    })
                }
            },

            searchResult() {
                this.$router.push({name: '002-1', params: { search: this.search }});
                this.bus.$emit('search', this.search)
            },

            warnMessage(message) {
                this.$message({
                    message: '警告: ' + message,
                    type: 'warning'
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// header.vue?9ac0763e